import { SelectOption } from './community.model';

export const allSelectOptionId = 0;
export const allSelectOption = new SelectOption(allSelectOptionId, '-');
